export const ActionTypes = {
  SET_AUTH_SESSION: 'SET_AUTH_SESSION',
  SET_DASHBOARD_DATA: 'SET_DASHBOARD_DATA',
  SET_JOBS: 'SET_JOBS',
  SET_TIMEZONES: 'SET_TIMEZONES',
  SET_USER_PROFILE: 'SET_USER_PROFILE',
  SET_UI_SETTING: 'SET_UI_SETTING',
  SET_FOLDERS: 'SET_FOLDERS'
};
